import React from "react";
import { injectIntl } from "react-intl";
import { Button, Icon } from "../index";
import styles from "./index.module.css";

const GeneralError = ({ intl }) => {
  const translate = (id) => intl.formatMessage({ id });
  return (
    <div className={styles.container} role="alert">
      <div className={styles.card}>
        <div className={styles.feedback}>
          <Icon icon="error" size="xl" />
          <h1 className={styles.title}>{translate("error_title")}</h1>
        </div>

        <p className={styles.description}>{translate("error_description")}</p>

        {/* {error && <pre className={styles.stack}>{String(error).slice(0, 1000)}</pre>} */}

        <div className={styles.actions}>
          <Button
            variant="grey-light"
            className={styles.button}
            onClick={() => window.location.reload()}
          >
            {translate("reload_page")}
          </Button>
          <Button variant="link" href="/">
            {translate("go_to_home")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(GeneralError);
